export function getSeoUrlFromFullUrl(fullUrl?: string): string {
  if (!fullUrl) {
    return '';
  }

  try {
    return new URL(fullUrl, window.location.origin).pathname;
  } catch {
    return '';
  }
}
